import { useEffect, useState } from "react";
import { useBrandingAdsChecker } from "@/hooks/useBrandingAdsChecker";

export default function useScrollingRect(sectionId: string, customRectValue?: number) {
  const [isCurrentSection, setCurrentSection] = useState(false);
  const { displayBranding } = useBrandingAdsChecker();

  useEffect(() => {
    const updateScrollPosition = () => {
      const element = document.getElementById(sectionId);

      if (!element) return;

      const rect = element.getBoundingClientRect();

      if (displayBranding) {
        setCurrentSection(rect.top <= 55);
      }
      if (customRectValue) {
        setCurrentSection(rect.top <= customRectValue);
      }

      // We need min. 2px spaces because on mobile a value < 2 causes the rect triggered all the time
      setCurrentSection(rect.top <= 2);
    };

    document.addEventListener("scroll", updateScrollPosition);

    return () => document.removeEventListener("scroll", updateScrollPosition);
  }, [displayBranding, customRectValue, sectionId]);

  return isCurrentSection;
}
